import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { VendorChatMessage } from '../models/VendorChatMessage';

@Injectable({
  providedIn: 'root',
})
export class VendorChatService {
  private readonly urlPath = 'vendor-chat';

  constructor(private httpClient: HttpClient) {}

  getMessages(vendorId: string): Observable<VendorChatMessage[]> {
    return this.httpClient.get<VendorChatMessage[]>(
      `${environment.apiUrl}${this.urlPath}/${vendorId}/messages`,
    );
  }

  sendMessage(vendorId: string, text: string): Observable<VendorChatMessage> {
    return this.httpClient.post<VendorChatMessage>(
      `${environment.apiUrl}${this.urlPath}/${vendorId}/messages`,
      { text },
    );
  }

  setReaction(
    vendorId: string,
    messageId: number,
    reaction: string | null,
  ): Observable<VendorChatMessage> {
    return this.httpClient.put<VendorChatMessage>(
      `${environment.apiUrl}${this.urlPath}/${vendorId}/messages/${messageId}/reaction`,
      { reaction },
    );
  }

  markMessagesRead(vendorId: string): Observable<void> {
    return this.httpClient.put<void>(
      `${environment.apiUrl}${this.urlPath}/${vendorId}/messages/read`,
      {},
    );
  }

  getUnreadCount(vendorId: string): Observable<number> {
    return this.httpClient.get<number>(
      `${environment.apiUrl}${this.urlPath}/${vendorId}/messages/unread-count`,
    );
  }
}
